import roadmapSprite from '@/assets/sprite/roadmap-sprite.svg';
import { Bet } from '@/modules/report/slice/betRecord';
import { Grid, Stack } from '@mui/material';

type Prop = {
    point: number;
};
const DiceIcon = (prop: Prop) => {
    const { point } = prop;
    const diceSize = '2rem';
    return (
        <svg
            width={diceSize}
            height={diceSize}
            viewBox="0 0 24 24"
            overflow={'visible'}
        >
            <use
                xlinkHref={`${roadmapSprite}#fishprawncrab__dice__die-${point}`}
                width={24}
                height={24}
            />
        </svg>
    );
};
export const FishPrawnCrabResultRecordPanel = ({ bet }: { bet: Bet }) => {
    const dices: number[] = bet.Result.split(',').map(str => Number(str));
    return (
        <>
            <Stack direction="row">
                {dices.map((d, idx) => {
                    return (
                        <Grid
                            key={`fpc-dice-${idx}`}
                            container
                            margin={'0 0.1rem'}
                        >
                            <DiceIcon point={d} />
                        </Grid>
                    );
                })}
            </Stack>
        </>
    );
};
